// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2uDap","upload":"Small_upload__JnDeI","imageWrap":"Small_imageWrap__xeyN7","removeBtn":"Small_removeBtn__2eWGy"};